import { RouteInterface, RoutesInterface } from '../../types/routes'

const sdgGapRoute: RouteInterface = {
  id: 'sdgap',
  label: 'Taxonomy',
  tooltip: 'SD(G)AP Taxonomy',
  path: '/sdgap/taxonomy/:type?/:code?',
  appPermissionId: 'app_sdgap',
  icon: 'fa-bullseye',
  auth: true,
}

const sdgGapPrimaryRoute: RouteInterface = {
  id: 'sdgap-primary-connections',
  label: 'Primary Connections',
  tooltip: 'SD(G)AP Primary Connections',
  path: '/sdgap/primary-connections/:type?/:code?',
  appPermissionId: 'app_sdgap',
  icon: 'fa-bullseye',
  auth: true,
}

export const sdgGapRoutes: RoutesInterface = {
  SDGAP: sdgGapRoute,
  SDGAP_PRIMARY_CONNECTIONS: sdgGapPrimaryRoute,
}
